import React from 'react';
import { FaPhone, FaWhatsapp, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

export default function Contact() {
  const phoneNumber = '+919876543210';
  const whatsappNumber = '919876543210';
 
  const address = 'Your Street Address, City, State 123456';

  return (
    <section id="contact" className="section">
      <h2 className="section-title">Get In Touch</h2>
      <p className="section-subtitle">We're here to help. Reach out to us anytime!</p>

      <div className="contact-grid">
        <div className="contact-card">
          <div className="contact-icon">
            <FaPhone />
          </div>
          <h3>Phone</h3>
          <p>
            <a href={`tel:${phoneNumber}`} className="contact-link">
              {phoneNumber}
            </a>
          </p>
          <p style={{ fontSize: '0.85rem', marginTop: '1rem', color: '#999' }}>
            Mon - Sun: 6 AM - 10 PM
          </p>
        </div>

        <div className="contact-card">
          <div className="contact-icon">
            <FaWhatsapp />
          </div>
          <h3>WhatsApp</h3>
          <p>
            <a 
              href={`https://wa.me/${whatsappNumber}?text=Hello%20Rudra%20Sports`} 
              className="contact-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Quick Chat
            </a>
          </p>
          <p style={{ fontSize: '0.85rem', marginTop: '1rem', color: '#999' }}>
            Instant replies to queries
          </p>
        </div>

        <div className="contact-card">
          <div className="contact-icon">
            <FaMapMarkerAlt />
          </div>
          <h3>Location</h3>
          <p>{address}</p>
          <p style={{ fontSize: '0.85rem', marginTop: '1rem', color: '#999' }}>
            Easy parking | Well connected
          </p>
        </div>

        <div className="contact-card">
          <div className="contact-icon">
            <FaEnvelope />
          </div>
          <h3>Email</h3>
          <p>
            <a href="mailto:info@rudrasports.com" className="contact-link">
              info@rudrasports.com
            </a>
          </p>
          <p style={{ fontSize: '0.85rem', marginTop: '1rem', color: '#999' }}>
            We'll respond within 2 hours
          </p>
        </div>
      </div>

      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15224.98617960924!2d78.53509794485642!3d17.46818539066031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b0051e44569%3A0x1014d4851105d344!2sRudra%20sports%20arena!5e0!3m2!1sen!2sin!4v1773743590981!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Rudra Sports Location"
        ></iframe>
      </div>

      <p style={{ 
        textAlign: 'center', 
        marginTop: '2rem', 
        color: '#999',
        fontSize: '0.9rem'
      }}>
      </p>
    </section>
  );
}
